import { IUserProfile } from "common";
import axios from "axios";

const appConfig = require("../app_config.json");

export default new class UserProfileService {
    async getUserProfile(token: string): Promise<IUserProfile> {
        const response = await axios.post(
            `${appConfig.baseUrl}${appConfig.stage}/load-user-profile`, 
            {}, 
            { headers: { "Authorization": token } }
        );

        return Promise.resolve(response.data);
    }

    async saveProfileAttribute(attribute: { name: string, value: any }, token: string): Promise<void> {
        await axios.post(
            `${appConfig.baseUrl}${appConfig.stage}/save-profile-attribute`, 
            {
                name:  attribute.name,
                value: attribute.value
            }, 
            { headers: { "Authorization": token } }
        );

        return Promise.resolve();
    }
}